import React, { useState } from 'react';
import styles from './addCandidateSpecialNoteModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import SpecialNoteReview from './specialNoteReview';
import SpecialNoteDetails from './specialNoteDetails';
import { addSpecialNote } from '../../../../services/util/candidates/index'

function AddCandidateSpecialNoteModal(props) {
    let [step, setStep] = useState(1);
    let [candidateID, setCandidateID] = useState(props.candidateID);
    let [noteData, setNoteData] = useState({
        note: '',
    })
    let [isLoading, setLoading] = useState(false);
    let [submissionLoading, setSubmissionLoading] = useState(false);


    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    const onSubmitNoteData = (values) => {
        setNoteData((prevState) => ({
            ...prevState,
            note: values.note
        }));
        nextPage(2);
    }


    const submitNoteDetailsValues = async () => {
        setSubmissionLoading(true);
        let respond = await addSpecialNote(candidateID, noteData.note);
        if (respond.success === true) {
            setSubmissionLoading(false);
            props.handleClose();
            if(props.getCandidateAllDetails){
                props.getCandidateAllDetails();
            }
        } else {
            setSubmissionLoading(false);
        }
    }



    return (
        <div>
             <Modal
                 show={props.showModal}
                 onHide={props.handleClose}
                 backdrop="static"
                 keyboard={false}
                 centered
                 size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Add Special Note</h2>
                    </div>
                    <Col sm={{ span: 8, offset: 2 }} className={styles.stepPosition}>

                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>
                                {
                                    step === 1 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_613_29628)">
                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_613_29628">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                }

                            </div>
                            <div className={step === 2 ? styles.stepActive : ''}>
                                {
                                    step === 2 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 2) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                     <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#EAECF0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <Container>
                            {/* Rendering Content Goes Here */}
                            {step === 1 && props.showModal === true && <SpecialNoteDetails onSubmitNoteData={onSubmitNoteData} closeModal={props.handleClose} noteData={noteData} />}
                            {step === 2 && props.showModal === true && <SpecialNoteReview previousPage={previousPage} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} noteData={noteData} submitNoteDetailsValues={submitNoteDetailsValues} submissionLoading={submissionLoading} />}
                        </Container>
                    </Col>
                </Modal.Body>

            </Modal>
        </div>
    )
}

export default AddCandidateSpecialNoteModal;
